import type { CSSProperties, ReactNode } from 'react';

interface SubtitleProps {
  children: ReactNode;
  /** When true (default), text is rendered in uppercase. */
  uppercase?: boolean;
  style?: CSSProperties;
  className?: string;
  as?: 'span' | 'p' | 'h2' | 'h3' | 'h4' | 'div';
}

export const Subtitle = ({
  children,
  uppercase = true,
  style,
  className,
  as: Tag = 'span',
}: SubtitleProps) => (
  <Tag
    className={className}
    style={{
      fontFamily: '"Inter Tight", "HK Grotesk SemiBold", -apple-system, "Segoe UI", sans-serif',
      fontSize: 13,
      fontWeight: 600,
      color: '#595959',
      textTransform: uppercase ? 'uppercase' : 'none',
      letterSpacing: uppercase ? '0.04em' : 'normal',
      margin: 0,
      ...style,
    }}
  >
    {children}
  </Tag>
);
